package top.wcpe.allincore.dsl.compiler.semantic.`native`

/**
 * 宿主 object 描述符。
 *
 * 描述一个内置宿主 object（如 net / local / vanilla）所拥有的方法集合。
 */
data class HostObjectDescriptor(
    /** 宿主 object 名称（如 "net"、"local"、"vanilla"）。 */
    val name: String,
    /** 该宿主 object 下所有方法描述符，key 为方法名。 */
    val methods: Map<String, MethodDescriptor>,
) {
    init {
        // 不变量：methods map 的 key 必须与对应 MethodDescriptor.name 一致
        for ((key, descriptor) in methods) {
            require(key == descriptor.name) {
                "HostObjectDescriptor '$name' 中 key '$key' 与 method.name '${descriptor.name}' 不一致"
            }
        }
    }

    /** 按方法名查找描述符；未注册返回 null。 */
    fun lookupMethod(method: String): MethodDescriptor? = methods[method]
}
